import React from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LoaderProvider } from "./context/LoaderContext";
import Home from "./pages/Home";
import Loader from "./components/Loader";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import BasicSearch from "./pages/BasicSearch";
import AdvanceSearch from "./pages/AdvanceSearch";
import ComprehensiveSearch from "./pages/ComprehensiveSearch";
import Matches from "./pages/MatchesList";
import Profile from "./pages/Profile";
import UserProfile from "./components/UserDataForm";
import AdminLogin from "./pages/Admin/AdminLogin";
import UsersTable from "./pages/Admin/Users";
import AdminDashbord from "./pages/Admin/Dashboard";
import AddProfile from "./pages/Admin/AddUserProfile";
import ProfileTable from "./pages/Admin/ProfileTable";

function App() {
  return (
    <LoaderProvider>
      <div className="App">
        <Loader />

        {/* Toast container yahan hamesha render hoga */}
        <ToastContainer position="top-right" autoClose={3000} />

        {/* Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/SignUp" element={<SignUp />} />
          <Route path="/BasicSearch" element={<BasicSearch />} />
          <Route path="/AdvanceSearch" element={<AdvanceSearch />} />
          <Route path="/ComprehensiveSearch" element={<ComprehensiveSearch />} />
          <Route path="/Matches" element={<Matches />} />
          <Route path="/Profile" element={<Profile />} />
          <Route path='/UserDataForm' element={<UserProfile/>} />

          {/* Admin Pages */}
          <Route path='/AdminLogin' element={<AdminLogin/>} />
          <Route path='/AdminDashbord' element={<AdminDashbord/>} />
          <Route path='/admin/UsersTable' element={<UsersTable/>} />
          <Route path='/admin/addProfile' element={<AddProfile/>} />
          <Route path='/admin/ProfileTable' element={<ProfileTable/>} />
        </Routes>
      </div>
    </LoaderProvider>
  );
}

export default App;
